export enum WorkspaceDocumentUploadStep {
  SelectDocuments = 'selectDocuments',
  SetDocumentProperties = 'setDocumentProperties',
}
